export default [
  {
    header: 'База <Музыка>',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Дэшборд',
    route: 'music-dashboard',
    icon: 'BarChart2Icon',
    resource: 'db-music',
    action: 'view',
  },
  {
    // Список артистов закрыт отдельным пермишшеном: контент-менеджеру выдают
    // artist-list без db-music.
    title: 'Исполнители',
    route: 'artists',
    icon: 'UsersIcon',
    resource: 'artist-list',
    action: 'view',
  },
  {
    title: 'Треки',
    route: 'tracks',
    icon: 'MusicIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Списки',
    route: 'lists',
    icon: 'ListIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Темы',
    route: 'autotopics',
    icon: 'ColumnsIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Треки без файлов',
    route: 'tracks-missing',
    icon: 'AlertCircleIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Треки без артиста',
    route: 'tracks-orphans',
    icon: 'UserXIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    // Подзаголовок на том же resource: внешние сервисы отделены от основной
    // работы с базой, но скрываются вместе с ней.
    header: 'Источники <Музыка>',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Найти в Last.FM',
    route: 'artists-search',
    icon: 'SearchIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Яндекс.Музыка',
    route: 'yandex-feed',
    icon: 'RadioIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Свежие релизы',
    route: 'fresh-releases',
    icon: 'DiscIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Kworb Чарты',
    route: 'kworb-chart',
    icon: 'TrendingUpIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Поиск Каверов',
    route: 'covers-search',
    icon: 'RepeatIcon',
    resource: 'db-music',
    action: 'view',
  },
  {
    title: 'Импорт плейлистов',
    route: 'music-import',
    icon: 'DownloadIcon',
    resource: 'db-music',
    action: 'view',
  },
]
